export default __webpack_public_path__ + "static/media/FacebookLogo.4a455df5.png";